(() => {
  const init = (root) => {
    if (!root || root.dataset.processReady === 'true') return;

    const track = root.querySelector('[data-process-track]');
    const cards = Array.from(root.querySelectorAll('[data-process-step]'));
    const previous = root.querySelector('[data-process-previous]');
    const next = root.querySelector('[data-process-next]');
    const indexLabel = root.querySelector('[data-process-index]');
    const mediaItems = Array.from(root.querySelectorAll('[data-process-image]'));
    const mediaLabel = root.querySelector('[data-process-media-label]');
    const mediaIndex = root.querySelector('[data-process-media-index]');

    if (!track || cards.length === 0 || !previous || !next || !indexLabel || mediaItems.length === 0) return;

    root.dataset.processReady = 'true';
    let activeIndex = 0;
    let frame = 0;

    root.processMediaPreloads = mediaItems
      .map((item) => item.querySelector('img'))
      .filter(Boolean)
      .map((image) => {
        const preload = new Image();
        preload.decoding = 'async';
        preload.src = image.currentSrc || image.src;
        return preload;
      });

    const cardOffset = (card) => card.offsetLeft - track.offsetLeft;

    const render = (index) => {
      activeIndex = Math.max(0, Math.min(index, cards.length - 1));
      cards.forEach((card, cardIndex) => {
        card.toggleAttribute('data-active', cardIndex === activeIndex);
      });
      mediaItems.forEach((item, itemIndex) => {
        const isActive = itemIndex === activeIndex;
        item.toggleAttribute('data-active', isActive);
        item.setAttribute('aria-hidden', String(!isActive));
      });
      indexLabel.textContent = String(activeIndex + 1).padStart(2, '0');
      if (mediaIndex) mediaIndex.textContent = String(activeIndex + 1).padStart(2, '0');
      if (mediaLabel) mediaLabel.textContent = cards[activeIndex].dataset.processLabel || '';
      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === cards.length - 1;
    };

    const nearestIndex = () => {
      const position = track.scrollLeft;
      return cards.reduce((nearest, card, index) => {
        const currentDistance = Math.abs(cardOffset(card) - position);
        const nearestDistance = Math.abs(cardOffset(cards[nearest]) - position);
        return currentDistance < nearestDistance ? index : nearest;
      }, 0);
    };

    const sync = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => render(nearestIndex()));
    };

    const goTo = (index) => {
      const boundedIndex = Math.max(0, Math.min(index, cards.length - 1));
      render(boundedIndex);
      track.scrollTo({ left: cardOffset(cards[boundedIndex]), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => goTo(activeIndex - 1));
    next.addEventListener('click', () => goTo(activeIndex + 1));
    track.addEventListener('scroll', sync, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(activeIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(activeIndex + 1);
      }
    });
    const hasFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    cards.forEach((card, index) => {
      card.addEventListener('click', () => {
        if (hasFinePointer.matches) render(index);
        else goTo(index);
      });
      card.addEventListener('focus', () => render(index));
      card.addEventListener('pointerenter', () => {
        if (hasFinePointer.matches) render(index);
      });
    });
    window.addEventListener('resize', sync, { passive: true });

    render(0);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-reglage-process]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
